import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import type {Nullish} from 'shared/web';

import {FinancingEndingEmailDialog} from '../components/FinancingEndingEmailDialog/FinancingEndingEmailDialog';
import type {FinancingEndingRowLabels} from '../components/FinancingEndingSkipSummary/FinancingEndingSkipSummary';
import {FINANCING_ENDING_EMAIL_DIALOG_ID} from '../constants/FINANCING_ENDING_EMAIL_DIALOG_ID';

export type OpenFinancingEndingEmailDialogParams = {
  rowIds: string[];
  rowLabels: FinancingEndingRowLabels[];
  dataQueryId: string | Nullish;
  onSubmitted: (bulkOperationId: string) => void;
};

export const openFinancingEndingEmailDialog = (params: OpenFinancingEndingEmailDialogParams) =>
  openDialog(
    <FinancingEndingEmailDialog
      rowIds={params.rowIds}
      rowLabels={params.rowLabels}
      dataQueryId={params.dataQueryId}
      onSubmitted={params.onSubmitted}
    />,
    {
      id: FINANCING_ENDING_EMAIL_DIALOG_ID,
      title: i18n.t('general.actions.sendEmail'),
      size: 'large',
      withAdditionalFooter: true,
      'data-testid': testIds.businessCase.financingEnding('emailDialog'),
    }
  );
